import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsvExportService {

  exportToCSV(list: any[], filename: string, flattenFn: (item: any) => any): void {
    if (list && list.length > 0) {
      const flattenedData = list.map(flattenFn);
      const headers = Object.keys(flattenedData[0]);
      const csvContent =
        '\ufeff' +
        headers.join(';') + '\n' +
        flattenedData.map(row => headers.map(field => this.formatCSVField(row[field])).join(';')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      this.downloadBlob(blob, filename);
    }
  }

  private formatCSVField(field: any): string {
    if (field === null || field === undefined) {
        return '';
    }
    const fieldString = field.toString().replace(/"/g, '""');
    if (fieldString.search(/("|;|\n)/g) >= 0) {
        return "${fieldString}"; // <-- CRASE!
    }
        return fieldString;
    }
  private downloadBlob(blob: Blob, filename: string) {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
}